
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 4.5V4A1.5 1.5 0 012 2.5h12A1.5 1.5 0 0115.5 4v.5m-15 0l6.227 3.736M.5 4.5V12m15-7.5L9.273 8.236M15.5 4.5V12M9.273 8.236L8 9l-1.273-.764m2.546 0L15.5 12m0 0v0a1.5 1.5 0 01-1.5 1.5H2A1.5 1.5 0 01.5 12v0m6.227-3.764L.5 12","stroke":"#000"}})])
          )
        }
      }
    